<template>
  <div>
    <cashback-balance-locks-table ref="cashbackTable" />
  </div>
</template>

<script>
import CashbackBalanceLocksTable from '@/modules/mobile/cashback/views/components/CashbackBalanceLocksTable.vue'

export default {
  name: 'CashbackBalanceLock',

  components: {
    CashbackBalanceLocksTable,
  },
}
</script>
